import { Middleware, PayloadAction } from '@reduxjs/toolkit';
import { notification } from 'antd';
import { IStore } from '../model/store';

interface ErrorPayload {
    status: string;
    statusText: string;
    stack: string;
    body?: {
      message?: string
    }
}

const middlewarePayloadGuard = (
  action: unknown,
): action is PayloadAction<ErrorPayload> => (
  typeof action === 'object'
    && action !== null
    && 'type' in action
    && typeof (action as PayloadAction).type === 'string'
    && 'payload' in action
    && typeof (action as PayloadAction<ErrorPayload>).payload === 'object'
    && 'status' in (action as PayloadAction<ErrorPayload>).payload
    && 'statusText' in (action as PayloadAction<ErrorPayload>).payload
    && 'stack' in (action as PayloadAction<ErrorPayload>).payload
);

export const errorHandlingMiddleware: Middleware<object, IStore> = () => (next) => (action: unknown) => {
  const result = next(action);
  if (middlewarePayloadGuard(action) && action.type.includes('rejected')) {
    const errorMessage = action.payload.body?.message;
    const status = action.payload?.status;
    const statusText = action.payload?.statusText;
    const stack = action.payload?.stack;

    if (errorMessage) {
      notification.error({
        type: 'error',
        message: 'Ошибка',
        description: errorMessage,
      });
    } else if (status && statusText) {
      notification.error({
        type: 'error',
        message: `Ошибка ${status}: ${statusText}`,
        description: stack || 'Произошла неизвестная ошибка',
      });
    } else {
      notification.error({
        type: 'error',
        message: 'Произошла ошибка',
        description: 'Попробуйте обновить страницу или обратитесь к администратору',
      });
    }
    return result;
  }
  return result;
};
